import moment from "moment";

export default function TableExportExcelPBA_GC(props) {
  const { data, dataSearch } = props;

  const fromDate = !dataSearch?.from
    ? "..............."
    : moment(dataSearch?.from).format("DD/MM/YYYY");
  const toDate = !dataSearch?.to
    ? "..............."
    : moment(dataSearch?.to).format("DD/MM/YYYY");

  const getCompensation = (item) => {
    return item?.elements?.find((i) => i.type_id === 319) || {};
  };

  return (
    <>
      <div style={{ display: "none" }}>
        <table
          className="collapse-border"
          id={"export-data-table-pba-gc"}
          data-cols-width="7, 15, 25, 30, 20, 17, 17, 35, 20, 22, 17, 17, 17, 17, 30, 30, 18, 17, 20, 18, 30, 35, 15, 25, 25, 18, 30"
        >
          <thead style={{ fontSize: "13" }}>
            <tr />
            <tr>
              <th />
              <th />
              <th />
              <th />
              <th />
              <th
                data-f-name={"Times new roman"}
                data-f-sz={"16"}
                data-b-a-s={"none"}
                data-f-bold={true}
              >
                BÁO CÁO CHI TIẾT HỒ SƠ BỒI THƯỜNG_BẢO HIỂM PHÚC BÌNH AN
              </th>
            </tr>
            <tr>
              <th />
              <th />
              <th />
              <th />
              <th />
              <th />
              <th
                data-f-name={"Times new roman"}
                data-f-sz={"12"}
                data-a-h={"left"}
                data-b-a-s={"none"}
                data-f-bold={true}
              >{`Từ ngày: ${fromDate} Đến Ngày: ${toDate} `}</th>
            </tr>
            <tr />
            <tr>
              <th
                colSpan={3}
                data-f-name={"Times new roman"}
                data-f-sz={"12"}
                data-a-wrap={true}
                data-a-h={"left"}
                data-b-a-s={"none"}
                data-f-bold={true}
              >
                {`Bên xuất báo cáo: Global Care`}
              </th>
            </tr>
            <tr />
            <tr />
            <tr style={{ fontSize: "13" }}>
              <Th>STT</Th>
              <Th>Ngày tạo HSBT</Th>
              <Th>Mã hồ sơ bồi thường</Th>
              <Th>Họ và tên chủ xe</Th>
              <Th>Biển số xe/ số khung/ số máy</Th>
              <Th>Số điện thoại</Th>
              <Th>Loại xe</Th>
              <Th>Hiệu lực bảo hiểm</Th>
              <Th>Loại tai nạn</Th>
              <Th>Mức độ tai nạn</Th>
              <Th>Loại hình điều trị</Th>
              <Th>Ngày nhập viện</Th>
              <Th>Ngày xuất viện</Th>
              <Th>Ngày tai nạn</Th>
              <Th>Nơi xảy ra tai nạn</Th>
              <Th>Nơi điều trị</Th>
              <Th>Tổng chi phí điều trị</Th>
              <Th>Ngày cập nhật</Th>
              <Th>Trạng thái bồi Thường</Th>
              <Th>Số tiền phê duyệt</Th>
              <Th>Người xử lý hồ sơ</Th>
              <Th>Nội dung</Th>
              <Th>Đối tượng thụ hưởng</Th>
              <Th>Họ và tên người thụ hưởng</Th>
              <Th>Ngân hàng</Th>
              <Th>Số tài khoản</Th>
              <Th>Chi nhánh</Th>
            </tr>
          </thead>
          <tbody style={{ fontSize: "13" }}>
            {props.data.map((item, index) => {
              return (
                <tr key={index} style={{ fontSize: "13" }}>
                  <Td>{index + 1}</Td>
                  <Td>
                    {item?.createdDate
                      ? moment(item?.createdDate).format("DD/MM/YYYY")
                      : ""}
                  </Td>
                  <Td>{item?.code || ""}</Td>
                  <Td>{item?.insuredInfo?.insuredName || ""}</Td>
                  <Td>{item?.insuredInfo?.licenseNumber || ""}</Td>
                  <Td>{item?.insuredInfo?.insuredPhone || ""}</Td>
                  <Td>{`Loại xe nhóm ${item?.insuredInfo?.typeId}`}</Td>
                  <Td>
                    {(item?.insuredInfo?.beginDate
                      ? `${moment(item?.insuredInfo?.beginDate).format(
                          "HH:mm DD/MM/YYYY"
                        )} - `
                      : "") +
                      (item?.insuredInfo?.endDate
                        ? `${moment(item?.insuredInfo?.endDate).format(
                            "HH:mm DD/MM/YYYY"
                          )}`
                        : "")}
                  </Td>
                  <Td>
                    {item?.extraInfo?.typeOfAccident === 1
                      ? "Tai nạn giao thông"
                      : ""}
                  </Td>
                  <Td>
                    {item?.extraInfo?.levelAccident === 1
                      ? "Tử vong"
                      : item?.extraInfo?.levelAccident === 2
                      ? "Thương tật vĩnh viễn"
                      : item?.extraInfo?.levelAccident === 3
                      ? "Thương tật tạm thời"
                      : ""}
                  </Td>
                  <Td>
                    {item?.extraInfo?.levelAccident !== 3
                      ? ""
                      : item?.extraInfo?.typeOfAccident === 1
                      ? "Ngoại trú"
                      : "Nội trú"}
                  </Td>
                  <Td>
                    {item?.extraInfo?.dateOfHospital ||
                    item?.extraInfo?.dayOfTreatment
                      ? moment(
                          item?.extraInfo?.dateOfHospital ||
                            item?.extraInfo?.dayOfTreatment
                        ).format("DD/MM/YYYY")
                      : ""}
                  </Td>
                  <Td>
                    {item?.extraInfo?.dateOutOfHospital ||
                    item?.extraInfo?.dayOfTreatment
                      ? moment(
                          item?.extraInfo?.dateOutOfHospital ||
                            item?.extraInfo?.dayOfTreatment
                        ).format("DD/MM/YYYY")
                      : ""}
                  </Td>
                  <Td>
                    {item?.extraInfo?.dateOfAccident
                      ? moment(item?.extraInfo?.dateOfAccident).format(
                          "DD/MM/YYYY"
                        )
                      : ""}
                  </Td>
                  <Td>{item?.extraInfo?.positionAccident || ""}</Td>
                  <Td>{item?.extraInfo?.treatmentPlace || ""}</Td>
                  <Td>
                    {item?.extraInfo?.totalAmountTreatment
                      ? `${item?.extraInfo?.totalAmountTreatment}`.replace(
                          /\B(?=(\d{3})+(?!\d))/g,
                          "."
                        ) + " VNĐ"
                      : ""}
                  </Td>
                  <Td>
                    {item?.updatedDate
                      ? moment(item.updatedDate).format("DD/MM/YYYY")
                      : ""}
                  </Td>
                  <Td>
                    {item.statusId === 2
                      ? "Đang xử lý"
                      : item.statusId === 3
                      ? "Đang đợi phê duyệt"
                      : item.statusId === 4
                      ? "Bổ sung hồ sơ"
                      : item.statusId === 5
                      ? "Phê duyệt"
                      : item.statusId === 6
                      ? "Hoàn tất"
                      : item.statusId === 7
                      ? "Từ chối"
                      : item.statusId === 8
                      ? "Khách hàng từ chối"
                      : ""}
                  </Td>
                  <Td>
                    {getCompensation(item)?.value
                      ? `${getCompensation(item)?.value}`.replace(
                          /\B(?=(\d{3})+(?!\d))/g,
                          "."
                        ) + " vnđ"
                      : ""}
                  </Td>
                  <Td>{item?.userFullnameReview || ""}</Td>
                  <Td>{getCompensation(item)?.text || ""}</Td>
                  <Td>
                    {+item?.insuredInfo?.relationshipWithBuyerId === 1
                      ? "Bản thân"
                      : "Người thân"}
                  </Td>
                  <Td>{item?.insuredInfo?.beneficiaryName || ""}</Td>
                  <Td>{item?.insuredInfo?.beneficiaryBankTitle || ""}</Td>
                  <Td>
                    {item?.insuredInfo?.beneficiaryBankAcountNumber || ""}
                  </Td>
                  <Td>{item?.insuredInfo?.beneficiaryBankBranchName || ""}</Td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
}

const Th = (props) => {
  return (
    <th
      data-f-name={"Times new roman"}
      data-f-sz={"12"}
      data-b-a-s={"thin"}
      data-a-h={"center"}
      data-a-wrap={true}
      data-f-bold={true}
    >
      {props.children}
    </th>
  );
};

const Td = (props) => {
  return (
    <th
      data-f-name={"Times new roman"}
      data-f-sz={"12"}
      data-b-a-s={"thin"}
      data-a-wrap={true}
    >
      {props.children}
    </th>
  );
};
